import type {Point} from 'highcharts';

import {TableColumnType} from 'common/components/data-table/types';
import {SectionItem} from 'common/components/items-menu/types';
import type {RenderLineChartTooltipParams} from 'common/report/insights/util/tooltip';

export type PopoverCallback = (
  segment: string,
  path?: string[],
  options?: {
    isTimeComparisonSegment?: boolean;
    highchartsPointContext?: Point;
    forSegmentColumn?: boolean;
    pointData?: RenderLineChartTooltipParams;
  },
) => SectionItem[];

export type PopoverActionCallbackOptions = {
  segment: string[];
  action: string;
  isTimeComparisonSegment?: boolean;
  color?: string | null;
  columnIndex?: number;
  columnType?: TableColumnType;
};

export type PopoverActionCallback = (options: PopoverActionCallbackOptions) => void;

export enum PopoverOption {
  Exclude = `exclude`,
  Filter = `filter`,
  RCA = `rca`,
  ViewEvents = `view_events`,
  ViewReplays = `view_replays`,
  ViewUsers = `view_users`,
  ZoomIn = `zoom_in`,
}

export enum AxisAssignment {
  Primary = `primary`,
  Secondary = `secondary`,
}
